import api from './api';

export const liveUpdatesService = {
  check: async (since = null) => {
    const params = since ? `?since=${encodeURIComponent(since)}` : '';
    const response = await api.get(`/live-updates/check${params}`);
    return response.data;
  },
};
